export interface PermissionsRoles {
  [key: string]: boolean;
}

export const permissionsRoles: PermissionsRoles = {
  menu: true,
  about: true,
  profile: true,
  author: true,
  book: true,
};
